export default __webpack_public_path__ + "static/media/bottom-banner-bg.0f33c63a.jpg";